// extracted by mini-css-extract-plugin
export default {"Heading":"ErrorPage-module__Heading--ucgNq","Status":"ErrorPage-module__Status--ITNSj","Message":"ErrorPage-module__Message--CAZL0"};